export default class EnrollmentCampaignInfoDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
    static getInfoTextFields(info) {
        const fields = [];
        if (info.departments.length) {
            fields.push({
                label: "Department(s)",
                value: info.departments.map(({ name }) => name).join(", "),
            });
        }
        if (info.academicCalendars.length) {
            fields.push({
                label: "Term(s)",
                value: info.academicCalendars.map(({ name }) => name).join(", "),
            });
        }
        if (info.courses.length) {
            fields.push({
                label: "Course(s)",
                value: info.courses
                    .map(({ name, code }) => (code ? `${name} (${code})` : name))
                    .join(", "),
            });
        }
        if (info.courseSections.length) {
            fields.push({
                label: "Course Section(s)",
                value: info.courseSections
                    .map(({ name, section, termName }) => section
                    ? `${name} - ${section} - ${termName}`
                    : `${name} - ${termName}`)
                    .join(", "),
            });
        }
        if (info.transcriptCourseStatuses.length) {
            fields.push({
                label: "Enrollment Status(es)",
                value: info.transcriptCourseStatuses
                    .map(({ description }) => description)
                    .join(", "),
            });
        }
        if (info.overrideTaskTitle) {
            fields.push({
                label: "Task  Title",
                value: info.overrideTaskTitle,
            });
        }
        if (info.overrideTaskDescription) {
            fields.push({
                label: "Task Description",
                value: info.overrideTaskDescription,
            });
        }
        return fields;
    }
}
